/**
 * Formats a given date input to dd-mm-yyyy.
 * Optionally includes time.
 * @param forceUTC - If true, treats the underlying date as UTC (useful for calendar events which should not be adjusted to local timezone).
 */
export function formatDate(dateInput: string | Date | undefined | null, includeTime = false, forceUTC = false): string {
    if (!dateInput) return 'N/A';
    
    const d = new Date(dateInput);
    if (isNaN(d.getTime())) return 'N/A';

    const dd = String(forceUTC ? d.getUTCDate() : d.getDate()).padStart(2, '0');
    const mm = String((forceUTC ? d.getUTCMonth() : d.getMonth()) + 1).padStart(2, '0');
    const yyyy = forceUTC ? d.getUTCFullYear() : d.getFullYear();

    let formattedDate = `${dd}-${mm}-${yyyy}`;

    if (includeTime) {
        const time = d.toLocaleTimeString([], { 
            hour: '2-digit', 
            minute: '2-digit', 
            timeZone: forceUTC ? 'UTC' : undefined 
        });
        formattedDate += `, ${time}`;
    }

    return formattedDate;
}
